import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class AppSettingsService {

    private appSettings;

    constructor (private injector: Injector) { }

    loadAppSettings() {
        let http = this.injector.get(HttpClient);

		const headers = new HttpHeaders(
			{
				'No-Auth':'True',
				'Content-Type': 'application/json',
			});
        
        return http.get('./assets/appsettings.json', {headers:headers}) //.subscribe((data)=>{console.log("AppSettings", data); this.appSettings = data;});
        .toPromise()
        .then(data => {
            console.log('retrieved appsettings.json');
            this.appSettings = data;
            console.log("appSettings Environment Name: ", this.appSettings.name);
        })
        .catch(err => { 
            console.log("Failed to read appsettings.json: ", err);
        });
    }

    get config() {
        if (null == this.appSettings)
        {
            console.log('appsettings was null');
            this.loadAppSettings();
        }
        // console.log(this.appSettings);
        return this.appSettings;
    }
}